import { wrapScrollViewHOC } from './hoc';
import { Container } from './container';
export * from "./hooks";
export const ScrollIntoView = Container;
export const wrapScrollView = (comp) => wrapScrollViewHOC(comp);
export const wrapScrollViewConfigured = (config) => (comp) => wrapScrollViewHOC(comp, config);
//# sourceMappingURL=index.js.map